
define('text!templates/widgets/dataGridCells/lStringCell.html',[],function () { return '<span data-bind="lString: {name: $data, data: $parent}"></span>\r';});

